import React from "react";
import Header from "../components/generalComponents/Header";
import BottomNavBar from "../components/generalComponents/BottomNavBar";
import AddBarcode from "../components/assortiment/AddBarcode";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

export default function AddBarcodeView(props) {
	return (
		<div className="pageWrapper">
			<Header title="Barcode toevoegen" needsLocation="Yes" />
			<div className="contentWrapper fadeInDelayed">
				<AddBarcode />
			</div>
			<BottomNavBar />
		</div>
	);
}

